import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Slider from '../../Components/Slider/Slider';
import {
  fetchTrendingMovies,
  fetchTopRatedMovies,
  fetchMoviesByGenre
} from '../../Api/Moviesapi';
import { ErrorState, LoadingState } from '../../Components/PageState/PageState';

const Movies = () => {
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [topRatedMovies, setTopRatedMovies] = useState([]);
  const [actionMovies, setActionMovies] = useState([]);
  const [comedyMovies, setComedyMovies] = useState([]);
  const [dramaMovies, setDramaMovies] = useState([]);
  const [status, setStatus] = useState({ loading: true, error: '' });

  useEffect(() => {
    const loadMovies = async () => {
      try {
        const [trending, topRated, action, comedy, drama] = await Promise.all([fetchTrendingMovies(), fetchTopRatedMovies(), fetchMoviesByGenre(28), fetchMoviesByGenre(35), fetchMoviesByGenre(18)]);
        setTrendingMovies(trending); setTopRatedMovies(topRated); setActionMovies(action); setComedyMovies(comedy); setDramaMovies(drama);
        setStatus({ loading: false, error: '' });
      } catch (error) { setStatus({ loading: false, error: error.message }); }
    };

    loadMovies();
  }, []);

  if (status.loading) return <LoadingState label="Loading movies…" />;
  if (status.error) return <ErrorState message={status.error} />;
  return (
    <Container fluid style={{ margin: 0, padding: 0, backgroundColor: '#111' }}>
      <Slider title="Trending Movies" movies={trendingMovies} />
      <Slider title="Top Rated Movies" movies={topRatedMovies} />
      <Slider title="Action Movies" movies={actionMovies} />
      <Slider title="Comedy Movies" movies={comedyMovies} />
      <Slider title="Drama Movies" movies={dramaMovies} />
    </Container>
  );
};

export default Movies;
